import {
  TextWidget,
  HeadingWidget,
  SpacerWidget,
  NavPillsWidget,
  NavPillsLargeWidget,
  ImageWidget,
  VideoWidget,
  TextAndImageWidget,
  CTABlockWidget,
  GalleryWidget,
  MapWidget,
  StandardEventsFeedWidget,
  IntroEventsFeedWidget,
  SliderEventsFeedWidget,
  PagesFeedWidget,
  BlogFeedWidget,
  PlacesFeedWidget,
  CitiesFeedWidget,
  RoutesFeedWidget,
  AudioGuidesFeedWidget,
  RoutePoint,
  AudioguidePoint,
  DictionaryOption,
  HistoryFiguresWidget,
  AdPlacementWidget,
  HotelsFeedWidget,
  CardsSetWidget,
  EventsPlacesRelationChosenWidgetInput
} from '@/utils/widgets/widgetsTypes.js'

export const commonWidgetList = [
  { title: 'Текст', ListItem: TextWidget },
  { title: 'Заголовок', ListItem: HeadingWidget },
  { title: 'Отступ', ListItem: SpacerWidget },
  { title: 'Навигационные кнопки', ListItem: NavPillsWidget },
  { title: 'Большие навигационные кнопки', ListItem: NavPillsLargeWidget },
  { title: 'Изображение', ListItem: ImageWidget },
  { title: 'Видео', ListItem: VideoWidget },
  { title: 'Текст и изображение', ListItem: TextAndImageWidget },
  { title: 'CTA блок', ListItem: CTABlockWidget },
  { title: 'Галерея', ListItem: GalleryWidget },
  { title: 'Карта', ListItem: MapWidget },
  { title: 'Подборка событий', ListItem: StandardEventsFeedWidget },
  { title: 'Интро слайдер с подборкой событий', ListItem: IntroEventsFeedWidget },
  { title: 'Слайдер с подборкой событий', ListItem: SliderEventsFeedWidget },
  { title: 'Слайдер выбранных событий/мест', ListItem: EventsPlacesRelationChosenWidgetInput },
  { title: 'Подборка страниц', ListItem: PagesFeedWidget },
  { title: 'Подборка постов блога', ListItem: BlogFeedWidget },
  { title: 'Подборка мест', ListItem: PlacesFeedWidget },
  { title: 'Подборка городов', ListItem: CitiesFeedWidget },
  { title: 'Подборка маршруштов', ListItem: RoutesFeedWidget },
  { title: 'Подборка аудиогидов', ListItem: AudioGuidesFeedWidget },
  { title: 'Рекламное место', ListItem: AdPlacementWidget },
  { title: 'Подборка отелей', ListItem: HotelsFeedWidget },
  { title: 'Набор карточек', ListItem: CardsSetWidget }
]

export const widgetListForCityAndPlaceList = [
  ...commonWidgetList,
  { title: 'Исторические личности', ListItem: HistoryFiguresWidget }
]

export const pointsList = [{ title: '', ListItem: RoutePoint }]
export const audioguidePointsList = [{ title: '', ListItem: AudioguidePoint }]
export const dictionaryOptionsList = [{ title: '', ListItem: DictionaryOption }]
